{
  "executeOption": {
    "title": "Option Execution",
    "sharesPerContract": "x 100 shares",
    "pcs": "pcs",
    "quantity": "Quantity",
    "side": {
      "buy": "Buy",
      "sell": "Sell"
    },
    "option": "Option",
    "strikePrice": "Strike Price, $",
    "sum": "Amount",
    "stocks": "Shares",
    "executeOption": "Execute Option",
    "availableMoney": "Available Funds",
    "optionExecuted": "Option executed successfully",
    "optionСouldNotBeExecuted": "Failed to execute option"
  }
}
